import { reactive, ref, computed } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as CommonEstimateFinal from '@/logic/common/CommonEstimateFinal'
import * as apiInquiry from '@/api/inquiry'
import * as apiContract from '@/api/contract'
import * as common from '@/util/common'
import { ESTIMATE_PRINT_DATA_NAME } from '@/util/constants'


// お見積もり内容の確認（入力）画面
export const getGroupIndex = (props, context) => {

  const group1 = reactive({

    applicationNo: '',
    created: '',
    createdDisp: computed(() => {
      return common.formatDate(group1.created)
    }),
    totalFee: 0,
    totalFeeDisp: computed(() => {
      return common.breakComma(group1.totalFee)
    }),
    expiration: '',
    expirationDisp: computed(() => {
      return common.formatDateKanji(group1.expiration)
    }),
    packageLists: [],

    // 支払い方法(6=振替・コンビニ、7=銀行振込)
    payment_classification: 0,

    // 入力エラーメッセージ
    error_payment_classification: '',

    // 送信中フラグ（二重送信防止用）
    isProcessing: false,

    currentDate: new Date(), // アクセス時の日付
    licensePeriodStart: computed(() => { // ライセンス期間（表示用） 翌月1日
      const startDate = new Date(group1.currentDate.getTime())
      // まずは当月の1日を設定し、その後その日の翌月を取得する。
      startDate.setDate(1)
      startDate.setMonth(startDate.getMonth() + 1)
      return `${startDate.getFullYear()}年${startDate.getMonth() + 1}月${startDate.getDate()}日`
    }),
    licensePeriodEnd: computed(() => { // ライセンス期間（表示用） 翌月1日+1年-1日
      const endDate = new Date(group1.currentDate.getTime())
      // まずは当月の1日を設定し、その後その日の翌月を取得する。
      endDate.setDate(1)
      endDate.setMonth(endDate.getMonth() + 1)
      // 更にその一年後-1日を取得する。
      endDate.setFullYear(endDate.getFullYear() + 1)
      endDate.setDate(endDate.getDate() - 1)
      return `${endDate.getFullYear()}年${endDate.getMonth() + 1}月${endDate.getDate()}日`
    }),

    /**
     * 初期表示
     */
    init: () => {

      // トークン認証し、ストアに保存されたデータを取得
      group1.applicationNo = store.state.estimateFinal.application_no
      group1.created = store.state.estimateFinal.created
      group1.totalFee = store.state.estimateFinal.total_fee
      group1.expiration = store.state.estimateFinal.expiration
      const packageLists = store.state.estimateFinal.package_lists
      
      // お見積もり内容の商品リストを表示用に整形する
      group1.packageLists = CommonEstimateFinal.arrangePackageLists(packageLists)
    },

    /**
     * 「お申し込み内容の確認」ボタンを押下した時
     */
    submitForIndex: () => {

      // お支払方法(ContactPaymentMethod)コンポーネントから渡された支払い方法IDを設定
      const paymentClassification = store.state.payment.paymentClassification

      if (paymentClassification === 0) {
        store.dispatch('common/showNotice', { title: 'エラー', text: '支払い方法IDが取得できませんでした。' })
        return
      }

      group1.payment_classification = paymentClassification

      // 入力チェック
      let isError = false

      if (group1.payment_classification === 0 || group1.payment_classification === '') {
        // ラジオボタンの初期値を設定しているので空になることは無いと思うが念のため
        group1.error_payment_classification = '必須項目です。'
        isError = true
      }

      if (isError) {
        // 入力エラーが存在した場合
        return false
      }

      // 入力内容を保持
      store.dispatch('estimateFinal/setPaymentClassification', group1.payment_classification)

      router.push({ path: '/public/estimate-final/confirm' })
    }
  })

  return group1
}

// お見積もり内容の確認（確認）画面
export const getGroupConfirm = (props, context) => {

  const group1 = reactive({

    // トークン（別ウィンドウで表示する印刷画面のトークン認証で使用）
    token: store.state.auth.token,

    applicationNo: '',
    created: '',
    createdDisp: computed(() => {
      return common.formatDate(group1.created)
    }),
    totalFee: 0,
    totalFeeDisp: computed(() => {
      return common.breakComma(group1.totalFee)
    }),
    expiration: '',
    expirationDisp: computed(() => {
      return common.formatDateKanji(group1.expiration)
    }),
    packageLists: [],

    // 支払い方法(6=振替・コンビニ、7=銀行振込)
    payment_classification: 0,

    // 支払い方法名
    paymentName: '',

    currentDate: new Date(), // アクセス時の日付
    licensePeriodStart: computed(() => { // ライセンス期間（表示用） 翌月1日
      const startDate = new Date(group1.currentDate.getTime())
      // まずは当月の1日を設定し、その後その日の翌月を取得する。
      startDate.setDate(1)
      startDate.setMonth(startDate.getMonth() + 1)
      return `${startDate.getFullYear()}年${startDate.getMonth() + 1}月${startDate.getDate()}日`
    }),
    licensePeriodEnd: computed(() => { // ライセンス期間（表示用） 翌月1日+1年-1日
      const endDate = new Date(group1.currentDate.getTime())
      // まずは当月の1日を設定し、その後その日の翌月を取得する。
      endDate.setDate(1)
      endDate.setMonth(endDate.getMonth() + 1)
      // 更にその一年後-1日を取得する。
      endDate.setFullYear(endDate.getFullYear() + 1)
      endDate.setDate(endDate.getDate() - 1)
      return `${endDate.getFullYear()}年${endDate.getMonth() + 1}月${endDate.getDate()}日`
    }),

    /**
     * 初期表示
     */
    init: () => {

      if (store.state.estimateFinal.payment_classification === 0) {
        // リロードした場合は、入力画面に強制的に戻す
        router.push({ path: '/public/estimate-final/index' })
        return
      }

      group1.payment_classification = Number(store.state.estimateFinal.payment_classification)

      // お見積もり内容確認APIをコール
      const params = {}
      params.type = 2 // 2:確認画面
      // 申込認証コード取得API のpay_methodが9の時は7にしてお見積もり内容確認APIをコールする
      if (group1.payment_classification === 9) {
        params.payment_classification = 7
      } else {
        params.payment_classification = group1.payment_classification
      }

      apiInquiry.confirmEstimate(params)
        .then(async(response) => {
          if (response) {
            const { data } = response

            if (data.status === 0) {
              group1.applicationNo = data.application_no
              group1.created = data.created
              group1.totalFee = data.total_fee
              group1.expiration = data.expiration
              group1.paymentName = data.payment

              const packageLists = data.package_lists

              // ストアに保持
              const data2 = {}
              data2.applicationNo = data.application_no
              data2.created = data.created
              data2.totalFee = data.total_fee
              data2.expiration = data.expiration
              data2.packageLists = data.package_lists
              data2.paymentName = data.payment
              store.dispatch('estimateFinal/setData', data2)
              
              // お見積もり内容の商品リストを表示用に整形する
              group1.packageLists = CommonEstimateFinal.arrangePackageLists(packageLists)

              // 印刷機能に渡すためのデータ(JSON)を生成し、ローカルストレージに保存
              // 保持するデータが多くならないよう必要なデータのみに絞る
              localStorage.removeItem(ESTIMATE_PRINT_DATA_NAME)
              const printData = {}
              printData.print_type = 'estimate-final'
              printData.name = data.agreement.name
              printData.total_fee = data.total_fee
              printData.package_lists = group1.packageLists
              const printJSON = JSON.stringify(printData)
              localStorage.setItem(ESTIMATE_PRINT_DATA_NAME, printJSON)
            }
          }
        })
    },

    /**
     * 「本契約を申し込む」ボタンを押下した時
     */
    submitForConfirm: () => {

      // 二重送信防止
      if (group1.isProcessing) {
        const payload = {
          title: '二重送信エラー',
          text: '短い時間に複数回送信ボタンが押されました。\n二重送信の可能性があるため、2度目以降の処理を中断します。'
        }
        store.dispatch('common/showNotice', payload)
        return
      }

      // 送信中フラグ（二重送信防止用）をtrueに設定
      group1.isProcessing = true
      if (store.state.estimateFinal.payment_classification === 1 || store.state.estimateFinal.payment_classification === 2 ||
        store.state.estimateFinal.payment_classification === 3 || store.state.estimateFinal.payment_classification === 9) {
        const params2 = {
          webuser_id: store.state.estimateFinal.webuser_id,
          identification_code: store.state.profile.identification_code,
          settlement_type: '',
          request_code: store.state.estimateFinal.offer_code_data.request_code,
          check: 2
        }
  
        if (store.state.estimateFinal.offer_code_data.pay_method === 2) {
          params2.settlement_type = 1
        } else if (store.state.estimateFinal.offer_code_data.pay_method === 3) {
          params2.settlement_type = 2
        } else {
          params2.settlement_type = store.state.estimateFinal.offer_code_data.pay_method
        }
  
        if (store.state.estimateFinal.offer_code_data.pay_method === 1) {
          params2.payment_type = 1
        } else if (store.state.estimateFinal.offer_code_data.pay_method === 2) {
          params2.payment_type = 2
        }
  
        apiContract
          .authWebUser(params2)
          .then(response => {
            const { data } = response
            if (data.status !== 0) {
              return false
            }
          })
      }

      // お見積もり内容確認API(データ登録処理)をコール
      // お見積もり内容確認APIのリクエストパラメータに支払い方法(payment_classfication)を設定すると登録完了処理になる
      const params = {}
      params.type = 3 // 3:完了画面
      if (store.state.estimateFinal.payment_classification === 9) {
        params.payment_classification = 7
      } else {
        params.payment_classification = store.state.estimateFinal.payment_classification
      }

      store.dispatch('common/showLoading')
      apiInquiry.confirmEstimate(params)
        .then(async(response) => {

          if (response) {
            const { data } = response

            if (data.status === 0) {

              group1.paymentName = data.payment

              // ストアに保持
              const data2 = {}
              data2.applicationNo = data.application_no
              data2.created = data.created
              data2.totalFee = data.total_fee
              data2.expiration = data.expiration
              data2.packageLists = data.package_lists
              data2.paymentName = data.payment
              store.dispatch('estimateFinal/setData', data2)
        
              // 完了画面に遷移
              router.push({ path: '/public/estimate-final/complete' })
            }
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })

    }
  })

  return group1
}

// お見積もり内容の確認（完了）画面
export const getGroupComplete = (props, context) => {

  const group1 = reactive({

    applicationNo: '',
    created: '',
    createdDisp: computed(() => {
      return common.formatDate(group1.created)
    }),
    totalFee: 0,
    totalFeeDisp: computed(() => {
      return common.breakComma(group1.totalFee)
    }),
    expiration: '',
    expirationDisp: computed(() => {
      return common.formatDateKanji(group1.expiration)
    }),
    packageLists: [],

    // 支払い方法(6=振替・コンビニ、7=銀行振込)
    payment_classification: 0,

    // 支払い方法名
    paymentName: '',

    currentDate: new Date(), // アクセス時の日付
    licensePeriodStart: computed(() => { // ライセンス期間（表示用） 翌月1日
      const startDate = new Date(group1.currentDate.getTime())
      // まずは当月の1日を設定し、その後その日の翌月を取得する。
      startDate.setDate(1)
      startDate.setMonth(startDate.getMonth() + 1)
      return `${startDate.getFullYear()}年${startDate.getMonth() + 1}月${startDate.getDate()}日`
    }),
    licensePeriodEnd: computed(() => { // ライセンス期間（表示用） 翌月1日+1年-1日
      const endDate = new Date(group1.currentDate.getTime())
      // まずは当月の1日を設定し、その後その日の翌月を取得する。
      endDate.setDate(1)
      endDate.setMonth(endDate.getMonth() + 1)
      // 更にその一年後-1日を取得する。
      endDate.setFullYear(endDate.getFullYear() + 1)
      endDate.setDate(endDate.getDate() - 1)
      return `${endDate.getFullYear()}年${endDate.getMonth() + 1}月${endDate.getDate()}日`
    }),

    /**
     * 初期表示
     */
    init: () => {

      group1.applicationNo = store.state.estimateFinal.application_no
      group1.created = store.state.estimateFinal.created
      group1.totalFee = store.state.estimateFinal.total_fee
      group1.expiration = store.state.estimateFinal.expiration
      const packageLists = store.state.estimateFinal.package_lists
      group1.payment_classification = store.state.estimateFinal.payment_classification
      group1.paymentName = store.state.estimateFinal.payment_name

      // お見積もり内容の商品リストを表示用に整形する
      group1.packageLists = CommonEstimateFinal.arrangePackageLists(packageLists)
      
    }
  })

  return group1
}
